import { Outlet, useLocation } from "react-router-dom";
import Footer from "../footer/Footer";
import LoadingSpinner from "../../loading/Loading";
import ProfileFunction from "../../functions/profileFunction/ProfileFunction";

export default function MainLayout() {
  ProfileFunction();

  const location = useLocation();
  const isChatPage = location.pathname.startsWith("/support/");

  return (
    <>
      <LoadingSpinner />
      <Outlet />
      {!isChatPage && <Footer />}
    </>
  );
}